import { FC } from 'react';

import MaterialIcon from '../../../../components/MaterialIcon/MaterialIcon';
import styles from './PhotoPicker.module.scss';
import { PhotoPreview } from './usePhotoPicker';

interface ThumbnailsProps {
  onRemove: (index: number) => void;
  previews: PhotoPreview[];
  processingCount: number;
  removeLabel: string;
}

const Thumbnails: FC<ThumbnailsProps> = ({ previews, processingCount, removeLabel, onRemove }) => (
  <>
    {previews.map(({ url, key }, idx) => (
      <div className={styles.thumb} key={key}>
        <img alt="" src={url} />
        <button
          aria-label={removeLabel}
          className={styles.remove}
          onClick={() => onRemove(idx)}
          type="button"
        >
          <MaterialIcon name="close" size={18} />
        </button>
      </div>
    ))}

    {Array.from({ length: processingCount }).map((_, i) => (
      <div className={styles.processingThumb} key={`p-${i}`}>
        <div className={styles.spinner} />
      </div>
    ))}
  </>
);

export default Thumbnails;
